// import React from "react";
// import Default from "../layouts/dashboard/default";
// import Index from "../views/dashboard/index";
// import UserProfile from "../views/dashboard/app/user-profile";
// import { roleTypes } from "../data/roleType";

// export const CommonRouter = [
//   {
//     path: "/",
//     element: <Default />,
//     children: [
//       {
//         path: "dashboard",
//         element: <Index />,
//         allowedRoles: [roleTypes.SUPER_ADMIN, roleTypes.ADMIN, roleTypes.SUPPLIER, roleTypes.PURCHASING, roleTypes.TECHNICIAN, roleTypes.WAREHOUSE],
//       },
//       {
//         path: "dashboard/app/user-profile",
//         element: <UserProfile />,
//       },
//     ],
//   },
// ];

import React from "react";
import Default from "../layouts/dashboard/default";
import { roleTypes } from "../data/roleType";
import PermissionWrapper from "./permission-wrapper";

// Import all components
import Index from "../views/dashboard/index";
import UserProfile from "../views/dashboard/app/user-profile";

// Account/User Management
import AccountList from "../views/dashboard/app/account-list";
import AccountAdd from "../views/dashboard/app/account-add";
import AccountEdit from "../views/dashboard/app/account-edit";
import WarehouseAccountList from "../views/dashboard/app/warehouse-account-list";
import WarehouseAccountAdd from "../views/dashboard/app/warehouse-account-add";
import WarehouseAccountEdit from "../views/dashboard/app/warehouse-account-edit";
import WarehouseAccountView from "../views/dashboard/app/warehouse-account-view";

// Stakeholder Management
import StakeholderList from "../views/dashboard/stakeholder/stakeholder-list";
import StakeholderAdd from "../views/dashboard/stakeholder/stakeholder-add";
import StakeholderEdit from "../views/dashboard/stakeholder/stakeholder-edit";
import StakeholderView from "../views/dashboard/stakeholder/stakeholder-view";

// Location Management
import LocationList from "../views/dashboard/location/location-list";
import LocationAdd from "../views/dashboard/location/location-add";

// Warehouse Management
import WarehouseList from "../views/dashboard/warehouse/warehouse-list";
import WarehouseAdd from "../views/dashboard/warehouse/warehouse-add";
import WarehouseEdit from "../views/dashboard/warehouse/warehouse-edit";

// Vendor Management
import VendorAdd from "../views/dashboard/vendor/vendor-add";
import VendorList from "../views/dashboard/vendor/vendor-list";

// System Management
import SystemAdd from "../views/dashboard/system/system-add";
import SystemList from "../views/dashboard/system/system-list";
import SystemEdit from "../views/dashboard/system/system-edit";

// Phase Management
import PhaseAdd from "../views/dashboard/phase/phase-add";
import PhaseList from "../views/dashboard/phase/phase-list";

// Rack Management
import RackAdd from "../views/dashboard/rack/rack-add";
import RackList from "../views/dashboard/rack/rack-list";
import RackEdit from "../views/dashboard/rack/rack-edit";

// Job Management
import JobAdd from "../views/dashboard/job/job-add";
import JobList from "../views/dashboard/job/job-list";
import JobEdit from "../views/dashboard/job/job-edit";
import JobView from "../views/dashboard/job/job-view";

// Product Request Management
import ProductRequestAdd from "../views/dashboard/product-request/product-request-add";
import ProductRequestList from "../views/dashboard/product-request/product-request-list";
import ProductRequestView from "../views/dashboard/product-request/product-request-view";
import ProductRequestEdit from "../views/dashboard/product-request/product-request-edit";

// Order Request Management
import OrderRequestAdd from "../views/dashboard/order-request/order-request-add";
import OrderRequestEdit from "../views/dashboard/order-request/order-request-edit";
import OrderReceiveReview from "../views/dashboard/order-request/order-receive-review";
import OrderRequestList from "../views/dashboard/order-request/order-request-list";
import OrderRequestView from "../views/dashboard/order-request/order-request-view";

// Order Receive Management
import OrderReceiveList from "../views/dashboard/order-receive/order-receive-list";

// Category Management
import CategoryAdd from "../views/dashboard/category/category-add";
import CategoryList from "../views/dashboard/category/category-list";

// Product Management
import ProductAdd from "../views/dashboard/product/product-add";
import ProductList from "../views/dashboard/product/product-list";
import ProductEdit from "../views/dashboard/product/product-edit";

// Manufacturer Management
import ManufacturerAdd from "../views/dashboard/manufacturer/manufacturer-add";
import ManufacturerList from "../views/dashboard/manufacturer/manufacturer-list";

// Role Management
import RoleList from "../views/dashboard/role/role-list";

// Permission Management
import PermissionList from "../views/dashboard/permission/permission-list";

// Quote
import Quote from "../views/dashboard/quote/quote";
import JobBomAdd from "../components/job-bom-add";
import JobBomEdit from "../components/job-bom-edit";
import JobBomView from "../components/job-bom-view";

export const CommonRoutes = [
  {
    path: "/",
    element: <Default />,
    allowedRoles: [
      roleTypes.SUPER_ADMIN,
      roleTypes.ADMIN,
      roleTypes.WAREHOUSE,
      roleTypes.SUPPLIER,
      roleTypes.PURCHASING,
    ],
    children: [
      // Dashboard Home
      {
        path: "dashboard",
        element: <Index />,
        allowedRoles: [
          roleTypes.SUPER_ADMIN,
          roleTypes.ADMIN,
          roleTypes.SUPPLIER,
          roleTypes.PURCHASING,
          roleTypes.WAREHOUSE,
        ],
      },

      // User Profile - Common to all roles
      {
        path: "dashboard/app/user-profile",
        element: <UserProfile />,
        allowedRoles: [
          roleTypes.SUPER_ADMIN,
          roleTypes.ADMIN,
          roleTypes.WAREHOUSE,
          roleTypes.SUPPLIER,
          roleTypes.PURCHASING,
        ],
      },

      // SUPER ADMIN ONLY ROUTES
      {
        path: "dashboard/app/role-list",
        element: (
          <PermissionWrapper allowedRoles={[roleTypes.SUPER_ADMIN]}>
            <RoleList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/user-add",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["create"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <AccountAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/user-list",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["delete", "view", "update", "status"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <AccountList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/user-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["update"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <AccountEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/quote",
        element: (
          <PermissionWrapper allowedRoles={[roleTypes.SUPER_ADMIN]}>
            <Quote />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/permission-list",
        element: (
          <PermissionWrapper allowedRoles={[roleTypes.SUPER_ADMIN]}>
            <PermissionList />
          </PermissionWrapper>
        ),
      },

      // ADMIN ONLY ROUTES (Super Admin can also access)
      {
        path: "dashboard/app/warehouse-add",
        element: (
          <PermissionWrapper allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}>
            <WarehouseAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/category-add",
        element: (
          <PermissionWrapper
            permissionKey="general_product_category"
            actionKeys={["create"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <CategoryAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/category-list",
        element: (
          <PermissionWrapper
            permissionKey="general_product_category"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <CategoryList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-add",
        element: (
          <PermissionWrapper
            permissionKey="general_product"
            actionKeys={["create"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <ProductAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-list",
        element: (
          <PermissionWrapper
            permissionKey="general_product"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <ProductList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="general_product"
            actionKeys={["update"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <ProductEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/manufacturer-add",
        element: (
          <PermissionWrapper
            permissionKey="manufacturer"
            actionKeys={["create"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <ManufacturerAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/manufacturer-list",
        element: (
          <PermissionWrapper
            permissionKey="manufacturer"
            actionKeys={["delete", "view", "update", "status"]}
            allowedRoles={[roleTypes.SUPER_ADMIN, roleTypes.ADMIN]}
          >
            <ManufacturerList />
          </PermissionWrapper>
        ),
      },

      // COMMON ADMIN ROUTES (Super Admin, Admin, Warehouse)
      {
        path: "dashboard/app/warehouse/user-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["update"]}
            allowedRoles={[roleTypes.WAREHOUSE]}
          >
            <WarehouseAccountEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/warehouse/user-add",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["create"]}
            allowedRoles={[roleTypes.WAREHOUSE]}
          >
            <WarehouseAccountAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/warehouse/user-list",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[roleTypes.WAREHOUSE]}
          >
            <WarehouseAccountList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/warehouse/user-view/:id",
        element: (
          <PermissionWrapper
            permissionKey="user"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[roleTypes.WAREHOUSE]}
          >
            <WarehouseAccountView />
          </PermissionWrapper>
        ),
      },

      // Stakeholder Management
      {
        path: "dashboard/app/stakeholder-add",
        element: (
          <PermissionWrapper
            permissionKey="stakeholder"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <StakeholderAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/stakeholder-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="stakeholder"
            actionKeys={["update", "delete_contact"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <StakeholderEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/stakeholder-view/:id",
        element: (
          <PermissionWrapper
            permissionKey="stakeholder"
            actionKeys={[
              "update",
              "delete",
              "view",
              "status",
              "delete_contact",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <StakeholderView />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/stakeholder-list",
        element: (
          <PermissionWrapper
            permissionKey="stakeholder"
            actionKeys={[
              "update",
              "delete",
              "view",
              "status",
              "delete_contact",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <StakeholderList />
          </PermissionWrapper>
        ),
      },

      // Location Management
      {
        path: "dashboard/app/location-add",
        element: (
          <PermissionWrapper
            permissionKey="location"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <LocationAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/location-list",
        element: (
          <PermissionWrapper
            permissionKey="location"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <LocationList />
          </PermissionWrapper>
        ),
      },

      // Warehouse Management
      {
        path: "dashboard/app/warehouse-list",
        element: (
          <PermissionWrapper
            permissionsList={[
              {
                permissionKey: "warehouse",
                actionKeys: [
                  "update",
                  "view",
                  "status",
                  "view_product_bin",
                  "fill_product_into_bin",
                  "view_warehouse_product",
                  "import_product",
                ],
              },
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <WarehouseList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/warehouse-edit/:id",
        element: (
          <PermissionWrapper
            permissionsList={[
              {
                permissionKey: "warehouse",
                actionKeys: [
                  "update",
                  "view_product_bin",
                  "fill_product_into_bin",
                  "view_warehouse_product",
                  "import_product",
                ],
              },
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <WarehouseEdit />
          </PermissionWrapper>
        ),
      },

      // Vendor Management
      {
        path: "dashboard/app/vendor-add",
        element: (
          <PermissionWrapper
            permissionKey="vendor"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <VendorAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/vendor-list",
        element: (
          <PermissionWrapper
            permissionKey="vendor"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <VendorList />
          </PermissionWrapper>
        ),
      },

      // System Management
      {
        path: "dashboard/app/system-add",
        element: (
          <PermissionWrapper
            permissionKey="system"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <SystemAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/system-list",
        element: (
          <PermissionWrapper
            permissionKey="system"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <SystemList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/system-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="system"
            actionKeys={["update"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <SystemEdit />
          </PermissionWrapper>
        ),
      },

      // Phase Management
      {
        path: "dashboard/app/phase-add",
        element: (
          <PermissionWrapper
            permissionKey="phase"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <PhaseAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/phase-list",
        element: (
          <PermissionWrapper
            permissionKey="phase"
            actionKeys={["update", "delete", "view", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <PhaseList />
          </PermissionWrapper>
        ),
      },

      // Rack Management
      {
        path: "dashboard/app/rack-add",
        element: (
          <PermissionWrapper
            permissionKey="rack_management"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <RackAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/rack-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="rack_management"
            actionKeys={["update", "update_bin_status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <RackEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/rack-list",
        element: (
          <PermissionWrapper
            permissionKey="rack_management"
            actionKeys={[
              "update",
              "delete",
              "view",
              "status",
              "update_bin_status",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <RackList />
          </PermissionWrapper>
        ),
      },

      // Job Management
      {
        path: "dashboard/app/job-add",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/job-list",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={[
              "update",
              "delete",
              "view",
              "status",
              "download_reports",
              "view_job_product_report",
              "update_job_item_status",
              "create_bom",
              "view_bom",
              "delete_bom",
              "edit_bom",
              "create_bom_pr",
              "print_bom",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/job-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={[
              "update",
              "view",
              "view_job_product_report",
              "update_job_item_status",
              "create_bom",
              "view_bom",
              "delete_bom",
              "edit_bom",
              "create_bom_pr",
              "print_bom",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/job-view/:id",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={["view", "update"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobView />
          </PermissionWrapper>
        ),
      },

      // Product Request Management - Available to multiple roles
      {
        path: "dashboard/app/product-request-add",
        element: (
          <PermissionWrapper
            permissionKey="product_request"
            actionKeys={["create", "add_custom_product"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.WAREHOUSE,
              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <ProductRequestAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-request-list",
        element: (
          <PermissionWrapper
            permissionKey="product_request"
            actionKeys={["update", "view", "delete", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <ProductRequestList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-request-view/:id",
        element: (
          <PermissionWrapper
            permissionKey="product_request"
            actionKeys={["update", "view", "delete", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <ProductRequestView />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/product-request-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="product_request"
            actionKeys={["update"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.WAREHOUSE,
              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <ProductRequestEdit />
          </PermissionWrapper>
        ),
      },

      // Purchase Order Management
      {
        path: "dashboard/app/purchase-order-add",
        element: (
          <PermissionWrapper
            permissionKey="purchase_order"
            actionKeys={["create"]}
            allowedRoles={[
              roleTypes.ADMIN,

              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <OrderRequestAdd />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/purchase-order-edit/:id",
        element: (
          <PermissionWrapper
            permissionKey="purchase_order"
            actionKeys={["update", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,

              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <OrderRequestEdit />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/purchase-order-receive-review/:id",
        element: (
          <PermissionWrapper
            permissionKey="purchase_order"
            actionKeys={["update", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,

              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
              roleTypes.WAREHOUSE,
            ]}
          >
            <OrderReceiveReview />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/purchase-order-list",
        element: (
          <PermissionWrapper
            permissionKey="purchase_order"
            actionKeys={["update", "view", "delete", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,

              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <OrderRequestList />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/purchase-order-view/:id",
        element: (
          <PermissionWrapper
            permissionKey="purchase_order"
            actionKeys={["update", "view", "delete", "status"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,

              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <OrderRequestView />
          </PermissionWrapper>
        ),
      },
      {
        path: "dashboard/app/job/:jobId/bom-add",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={["create_bom"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobBomAdd />
          </PermissionWrapper>
        ),
      },

      {
        path: "dashboard/app/job-edit/:id/bom-edit/:bomId",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={["edit_bom", "create_bom_pr"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobBomEdit />
          </PermissionWrapper>
        ),
      },

      {
        path: "dashboard/app/job-edit/:id/bom-view/:bomId",
        element: (
          <PermissionWrapper
            permissionKey="job"
            actionKeys={[
              "view_bom",
              "delete_bom",
              "edit_bom",
              "create_bom_pr",
              "print_bom",
            ]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
            ]}
          >
            <JobBomView />
          </PermissionWrapper>
        ),
      },
      // Order Receive Management
      {
        path: "dashboard/app/receiving-order",
        element: (
          <PermissionWrapper
            permissionKey="receiving"
            actionKeys={["view"]}
            allowedRoles={[
              roleTypes.ADMIN,
              roleTypes.SUPER_ADMIN,
              roleTypes.WAREHOUSE,
              roleTypes.SUPPLIER,
              roleTypes.PURCHASING,
            ]}
          >
            <OrderReceiveList />
          </PermissionWrapper>
        ),
      },
    ],
  },
];
